import React, { Component } from "react";
import styled, { css } from "styled-components";
import Header from "./Header";
import MessageList from "./ContentWithWs";
import Footer from "./Footer";
import { AddDroppedFiles, AddMessageToStore } from '../Store'
import { Button, ButtonGroup } from "@mui/material";
import NetworkIndicator from "../module-common/NetworkIndicator";
export default class ChatBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      waitingForConfirmation: false,
      onCloseTriggered: false
    }
  }

  onCloseFromHeader = () => {
    this.props.onClose();
  };

  render() {
    const { onClose, onMinimize } = this.props
    const { onCloseTriggered } = this.state
    return (
      <Wrapper>
        <Header 
          onMinimize={e => onMinimize && onMinimize(e)} 
          // onClose={e => {
          //   this.setState({ onCloseTriggered: !onCloseTriggered })
          // }} 
        />
        <Body>
          <Overlay active={onCloseTriggered}>
            Are you sure to end the chat session?
            <ButtonGroup variant='custom'>
              <Button color='warning' onClick={e => {
                onClose && onClose(e)
              }}>Yes</Button>
              <Button onClick={e => this.setState({ onCloseTriggered: false })}>No</Button>
            </ButtonGroup>
          </Overlay>
          <NetworkIndicator />
          <div style={{ height: 'calc(100% - 80px)' }}>
            <MessageList
              onFileDrop={(fileList) => {
                AddDroppedFiles(fileList)
              }}
            />
          </div>
          <Footer />

        </Body>
      </Wrapper>
    );
  }
}

const Overlay = styled.div`
  padding: 5px;
  # background: #4ebce8;
  background: linear-gradient(90deg,#2db7a2,#35adac,#4e8ec8);
  height: 0%;
  position: absolute;
  z-index: 999;
  width: 100%;
  display: none;
  ${props =>
    props.active && css`
      height: 100%;
      display: block;
      color: #000;
      font-size: 14px;
      text-align: center;
    `
  }
`

const Body = styled.div`
  height: 100%;
  position: relative;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 275px;
  height: 375px;
  right: 0px;
  bottom: 0px;
  background: white;
  border-radius: 5px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.2);
  @media (max-width: 600px) {
    position: absolute;
    right: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
    background: white;
    border-radius: 5px;
  }
`;
